import React, { useState } from 'react';
import './inClassActivities.css';

function C2wInClassActivities() {
  const tabs = [
    { id: 'qa', label: 'Q&A Section', color: '#ffb400' },
    { id: 'practical', label: 'Practical Exposure', color: '#d146ad' },
    // { id: 'doubt', label: 'Doubt Solving', color: '#00e676' },
    // { id: 'challenges', label: 'Coding Challenges', color: '#ff5272' },
    // { id: 'problem', label: 'Problem Solving & Innovation', color: '#1675f2' }
  ];

  const [activeTab, setActiveTab] = useState('practical');

  // We can show different glimpses for different tabs, or have a default gorgeous set
  const glimpses = {
    practical: [
      {
        col: 1,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/1.png', alt: 'Practical Exposure 1', className: 'img-horizontal' },
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/3.png', alt: 'Practical Exposure 3', className: 'img-horizontal' }
        ]
      },
      {
        col: 2,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/4.jpg', alt: 'Practical Exposure 4', className: 'img-vertical' },
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/5.jpg', alt: 'Practical Exposure 5', className: 'img-horizontal' }
        ]
      },
      {
        col: 3,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/6.png', alt: 'Practical Exposure 6', className: 'img-horizontal' },
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/7.jpg', alt: 'Practical Exposure 7', className: 'img-vertical' },
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/9.png', alt: 'Practical Exposure 9', className: 'img-horizontal' }
        ]
      },
      {
        col: 4,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/10.png', alt: 'Practical Exposure 10', className: 'img-vertical' },
          { type: 'image', src: '/assets/full%20stack/photos/PracticalExposure/11.png', alt: 'Practical Exposure 11', className: 'img-horizontal' }
        ]
      }
    ],
    qa: [
      {
        col: 1,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/QA/1.png', alt: 'Q&A Session 1', className: 'img-vertical' },
          { type: 'image', src: '/assets/full%20stack/photos/QA/2.png', alt: 'Q&A Session 2', className: 'img-horizontal' }
        ]
      },
      {
        col: 2,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/QA/3.png', alt: 'Q&A Session 3', className: 'img-horizontal' },
          { type: 'image', src: '/assets/full%20stack/photos/QA/4.png', alt: 'Q&A Session 4', className: 'img-vertical' }
        ]
      },
      {
        col: 3,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/QA/5.png', alt: 'Q&A Session 5', className: 'img-vertical' },
          { type: 'image', src: '/assets/full%20stack/photos/QA/6.png', alt: 'Q&A Session 6', className: 'img-horizontal' },
          { type: 'image', src: '/assets/full%20stack/photos/QA/7.png', alt: 'Q&A Session 7', className: 'img-horizontal' }
        ]
      },
      {
        col: 4,
        items: [
          { type: 'image', src: '/assets/full%20stack/photos/QA/8.png', alt: 'Q&A Session 8', className: 'img-horizontal' },
          { type: 'image', src: '/assets/full%20stack/photos/QA/9.png', alt: 'Q&A Session 9', className: 'img-vertical' }
        ]
      }
    ],
    doubt: [
      {
        col: 1,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image15.jpeg', alt: 'Doubt Clearing 1', className: 'img-horizontal' }
        ]
      },
      {
        col: 2,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image16.jpeg', alt: 'Doubt Clearing 2', className: 'img-vertical' },
          { type: 'image', src: '/assets/images/gallery/Image17.jpeg', alt: 'Doubt Clearing 3', className: 'img-vertical' }
        ]
      },
      {
        col: 3,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image18.jpeg', alt: 'Doubt Clearing 4', className: 'img-horizontal' },
          { type: 'image', src: '/assets/images/gallery/Image19.jpeg', alt: 'Doubt Clearing 5', className: 'img-horizontal' }
        ]
      },
      {
        col: 4,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image20.jpeg', alt: 'Doubt Clearing 6', className: 'img-vertical' }
        ]
      }
    ],
    challenges: [
      {
        col: 1,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image21.jpeg', alt: 'Coding Challenge 1', className: 'img-vertical' }
        ]
      },
      {
        col: 2,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image22.jpeg', alt: 'Coding Challenge 2', className: 'img-horizontal' },
          { type: 'image', src: '/assets/images/gallery/Image26.png', alt: 'Coding Challenge 3', className: 'img-ui-mock' }
        ]
      },
      {
        col: 3,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image10.jpeg', alt: 'Coding Challenge 4', className: 'img-vertical' },
          { type: 'image', src: '/assets/images/gallery/Image12.jpeg', alt: 'Coding Challenge 5', className: 'img-horizontal' }
        ]
      },
      {
        col: 4,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image14.jpeg', alt: 'Coding Challenge 6', className: 'img-vertical' }
        ]
      }
    ],
    problem: [
      {
        col: 1,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image1.jpeg', alt: 'Group Work', className: 'img-horizontal' }
        ]
      },
      {
        col: 2,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image4.jpeg', alt: 'Brainstorming', className: 'img-vertical' },
          { type: 'image', src: '/assets/images/gallery/Image25.png', alt: 'Design Mockup', className: 'img-ui-mock' }
        ]
      },
      {
        col: 3,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image18.jpeg', alt: 'Problem Solving', className: 'img-vertical' },
          { type: 'image', src: '/assets/images/gallery/Image2.jpeg', alt: 'Certificate Presentation', className: 'img-vertical' }
        ]
      },
      {
        col: 4,
        items: [
          { type: 'image', src: '/assets/images/gallery/Image7.jpeg', alt: 'Innovation Session', className: 'img-horizontal' }
        ]
      }
    ]
  };

  const activeGlimpses = glimpses[activeTab] || glimpses['practical'];

  return (
    <div className="C2wInClassActivities_ctn">
      <div className="activities-badge">
        <span className="badge-icon">💡</span>
        <span>LEARN, PRACTICE, GROW</span>
      </div>

      <h2 className="activities-heading">
        In Class <span className="highlight-blue">Activities</span>
      </h2>

      <p className="activities-subheading">
        At Core2web, learning goes beyond theory. Our in-class activities are designed to build practical skills, boost creativity, and prepare you for real-world challenges.
      </p>

      {/* Tabs */}
      <div className="activities-tabs-row">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`activity-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            style={{ '--tab-accent-color': tab.color }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Glimpses Subtitle */}
      <h3 className="glimpses-subtitle">Glimpses of Our In class Activities</h3>

      {/* Masonry Glimpses Grid */}
      <div className="glimpses-grid">
        {activeGlimpses.map((column, colIdx) => (
          <div className="glimpses-column" key={colIdx}>
            {column.items.map((item, itemIdx) => {
              if (item.type === 'purple-box') {
                return (
                  <div className="glimpses-purple-box" key={itemIdx}>
                    {item.images.map((imgSrc, imgIdx) => (
                      <div className="purple-box-image-wrapper" key={imgIdx}>
                        <img src={imgSrc} alt="Slide Preview" />
                      </div>
                    ))}
                  </div>
                );
              }
              return (
                <div className={`glimpses-image-card ${item.className}`} key={itemIdx}>
                  <img src={item.src} alt={item.alt} />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default C2wInClassActivities;
